import React from "react";
import * as HIcons from '@heroicons/react/24/outline';

const Icon = ({iconName, ...rest}) => {
  const {...icons} = HIcons
  const SelectedIcon = icons[iconName]
  return <SelectedIcon {...rest} />;
};

export default Icon;
